var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._m(1),_c('panel',{attrs:{"title":"Panel title here"}},[_c('vue-good-table',{directives:[{name:"columns-resizable",rawName:"v-columns-resizable"}],attrs:{"columns":_vm.columns,"rows":_vm.rows,"line-numbers":true,"pagination-options":{
				enabled: true,
				mode: 'records',
				perPage: 5,
				nextLabel: '下一页',
				prevLabel: '上一页',
				rowsPerPageLabel: '每页行数',
				ofLabel: '行，共',
				pageLabel: 'page', // for 'pages' mode
				allLabel: '全部',
			}}},[_vm._v(" > ")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb float-xl-right"},[_c('li',{staticClass:"breadcrumb-item active"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("Home")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"page-header"},[_vm._v("Home "),_c('small',[_vm._v("header small text goes here...")])])}]

export { render, staticRenderFns }